import React from 'react'
import PropTypes from 'prop-types'
import RemoveCutSVG from './assets/RemoveCutSVG.jsx'
import priceCalculator from './helpers/price_calculator'
import './assets/inputs.scss'
import TubeSVG from './assets/TubeSVG.jsx'

const Cut = ({
  cut, index, onDeleteCut, vatRate
}) => {
  const fieldName = (name) => (
    `${name}[${index}]`
  )

  const priceWithoutVAT = () => (
    priceCalculator.priceWithoutVAT(cut.length, cut.product, cut.quantity)
  )

  const priceWithVAT = () => (
    priceCalculator.priceWithVAT(cut.length, cut.product, cut.quantity, vatRate)
  )

  return (
    <>
      <tr>
        <td className="cts-remove">
          <button
            id={fieldName('remove_cut')}
            className="remove-cut input"
            onClick={() => onDeleteCut(index)}
            type="button"
          >
            <RemoveCutSVG />
          </button>
          <input name={fieldName('size')} value={cut.product.id} type="hidden"/>
          <input name={fieldName('length')} value={cut.length} type="hidden"/>
          <input name={fieldName('quantity')} value={cut.quantity} type="hidden"/>
        </td>
        <td>
          {cut.product.size_a} mm
        </td>
        <td>
          {cut.length} mm
        </td>
        <td>
          {cut.quantity}
        </td>
        <td>
          £{priceWithoutVAT()}
        </td>
        <td>
          £{priceWithVAT()}
        </td>
      </tr>
      <tr>
        <td></td>
        <td colSpan="5">
          <div className="tube-svg"><TubeSVG size={cut.product.size_a} length={cut.length}/></div>
        </td>
      </tr>
    </>
  )
}

Cut.propTypes = {
  cut: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onDeleteCut: PropTypes.func.isRequired,
  vatRate: PropTypes.number.isRequired
}

export default Cut
